import React from 'react';
import { Routes, Route } from 'react-router-dom';
import OverviewSection from '../../components/customer/CustomerDashboard/CustomerDashboardpages/OverviewSection';
import AIPlanner from '../../components/customer/CustomerDashboard/CustomerAiPlanner/AIPlanner';
import WishlistSection from '../../components/customer/CustomerDashboard/CustomerWishlistSection/WishListSection';
import NotificationSettings from '../../components/customer/CustomerDashboard/CustomerSettings/NotificationsSettings';
import SecuritySettings from '../../components/customer/CustomerDashboard/CustomerSettings/SecuritySettings';
import MyProfile from '../../components/customer/CustomerDashboard/CustomerProfile/MyProfile';
 import CustomerTestimonials from '../../screens/customer/CustomerTestimonials/CustomerTestimonials';
import CustomerNotifications from '../../screens/customer/CustomerNotification/CustomerNotifications';
import CusSupportDashboard from '../../screens/customer/CustomerSupport/CusSupportDashboard';
import CusSupportCreate from '../../screens/customer/CustomerSupport/CusSupportCreate';
import CusSupportTicketsList from '../../components/customer/CustomerDashboard/CustomerSupportPage/CusSupportTicketsList';
import CusSupportDetail from '../../screens/customer/CustomerSupport/CusSupportDetail';
import ScrollToTop from '../../components/general/ScrollToTop';
const CustomerDashboardRoutes = () => {
  return (
    <> <ScrollToTop />
    <Routes>
       
      {/* Main Dashboard Routes */}
      <Route path="/" element={<OverviewSection />} />
      <Route path="/dashboard" element={<OverviewSection />} />
      <Route path="/ai-planner" element={<AIPlanner />} />
      <Route path="/wishlist" element={<WishlistSection />} />
      <Route path="/cus-notifications" element={<CustomerNotifications />} />
      <Route path="/profile" element={<MyProfile />} />
      <Route path="/help-support" element={<CusSupportDashboard/>} />
         <Route path="/support/create" element={<CusSupportCreate/>} />
         <Route path="/support/tickets" element={<CusSupportTicketsList/>} />
         <Route path="/support/tickets/:id" element={<CusSupportDetail/>} />
         
      <Route path="/settings/notifications" element={<NotificationSettings />} />
      <Route path="/settings/security" element={<SecuritySettings />} />
      
      <Route path="*" element={<OverviewSection />} />
    </Routes>
     </>
  );
};

export default CustomerDashboardRoutes;